// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* #installAppModal * {
    font-family: Poppins;
} */

.pwa-header h2 {
    margin: 0;
    font-size: 1.5rem;
    text-align: center;
}

.pwa-header p {
    margin: 8px 0 16px;
    font-size: 1rem;
    text-align: center;
}

.pwa-benefits {
    display: flex;
    flex-direction: column;
    gap: 10px;
}

.pwa-benefits h3,
.pwa-steps h3,
.pwa-header p {
    font-size: 1.1rem;
    margin: 12px 0 8px;
}

.pwa-benefits ul,
.pwa-steps ol {
    padding-left: 20px;
    margin: 0 0 16px;
    font-size: 0.95rem;
    list-style-type: disc;
    font-weight: 500;
}

.pwa-benefits li,
.pwa-steps li {
    margin-bottom: 8px;
    line-height: 1.4;
}

.pwa-install-popup {
    display: flex;
    flex-direction: column;
    gap: 15px;
}

.pwa-install-popup li span {
    font-weight: 500;
}

.install-box {
    background: #D6EBF0 ;
    border: 1px solid #26545F;
    border-radius: 6px;
    padding: 12px;
    color: #25535E !important;
}

.install-warning {
    background-color: #E2E3E5;
    border: 1px solid #383D41;
    border-radius: 6px;
    padding: 12px;
    color: #383D41 !important;
}

.install-box ol {
    margin-left: 24px;
}

.benefits ul {
    margin-left: 15px;
    list-style-type: decimal;
}

.install-box-title {
    font-size: 14px;
    font-weight: 500;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/layout/app-install-popup/app-install-popup.component.css"],"names":[],"mappings":"AAAA;;GAEG;;AAEH;IACI,SAAS;IACT,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;;;IAGI,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;;IAEI,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;IAClB,qBAAqB;IACrB,gBAAgB;AACpB;;AAEA;;IAEI,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,oBAAoB;IACpB,yBAAyB;IACzB,kBAAkB;IAClB,aAAa;IACb,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,yBAAyB;IACzB,kBAAkB;IAClB,aAAa;IACb,yBAAyB;AAC7B;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;IACjB,wBAAwB;AAC5B;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB","sourcesContent":["/* #installAppModal * {\n    font-family: Poppins;\n} */\n\n.pwa-header h2 {\n    margin: 0;\n    font-size: 1.5rem;\n    text-align: center;\n}\n\n.pwa-header p {\n    margin: 8px 0 16px;\n    font-size: 1rem;\n    text-align: center;\n}\n\n.pwa-benefits {\n    display: flex;\n    flex-direction: column;\n    gap: 10px;\n}\n\n.pwa-benefits h3,\n.pwa-steps h3,\n.pwa-header p {\n    font-size: 1.1rem;\n    margin: 12px 0 8px;\n}\n\n.pwa-benefits ul,\n.pwa-steps ol {\n    padding-left: 20px;\n    margin: 0 0 16px;\n    font-size: 0.95rem;\n    list-style-type: disc;\n    font-weight: 500;\n}\n\n.pwa-benefits li,\n.pwa-steps li {\n    margin-bottom: 8px;\n    line-height: 1.4;\n}\n\n.pwa-install-popup {\n    display: flex;\n    flex-direction: column;\n    gap: 15px;\n}\n\n.pwa-install-popup li span {\n    font-weight: 500;\n}\n\n.install-box {\n    background: #D6EBF0 ;\n    border: 1px solid #26545F;\n    border-radius: 6px;\n    padding: 12px;\n    color: #25535E !important;\n}\n\n.install-warning {\n    background-color: #E2E3E5;\n    border: 1px solid #383D41;\n    border-radius: 6px;\n    padding: 12px;\n    color: #383D41 !important;\n}\n\n.install-box ol {\n    margin-left: 24px;\n}\n\n.benefits ul {\n    margin-left: 15px;\n    list-style-type: decimal;\n}\n\n.install-box-title {\n    font-size: 14px;\n    font-weight: 500;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
